



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IWallet } from "@/interfaces";
import DelegateService from "@/services/delegate";

@Component({
  components: {
    WalletVoters,
  },
})
export default class WalletVoters extends Vue {
  @Prop({ required: true }) public wallet: IWallet;

  private voterCount = 0;

  get delegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.publicKey);
  }

  @Watch("wallet")
  public async onWalletChange(wallet: IWallet) {
    if (wallet.username) {
      await this.getVoterCount();
    }
  }

  public async mounted() {
    await this.getVoterCount();
  }

  private async getVoterCount() {
    const count = await DelegateService.voterCount(this.wallet.publicKey);
    this.voterCount = count;
  }
}
